import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getCurrentUser } from 'modules/user';

import LoadingOverlay from 'components/LoadingOverlay';

class ProfilePage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  };

  componentWillMount() {
    const { isLoading, isLoaded, dispatch } = this.props;

    // Do not fetch request if request already sent
    if ( ! isLoading && ! isLoaded ) {
      dispatch(getCurrentUser());
    }
  }

  /**
   * Render Profile Data
   */
  renderProfileData() {
    const { user } = this.props;
    const data = [
      {
        label: 'Nama',
        value: user.fullname
      },
      {
        label: 'Email',
        value: user.email
      },
      {
        label: 'Rekening Bank',
        value: user.bank_account
      }
    ];

    return data.map((item, index) => {
      return (
        <div className="profile-data" key={index}>
          <div className="profile-data__label">{item.label}</div>
          <div className="profile-data__value">{item.value}</div>
        </div>
      );
    })
  }

  /**
   * Render Logo
   */
  renderLogo() {
    const { user } = this.props;

    return (
      <div className="profile-data">
        <img src={user.logo} alt={user.fullname} />
      </div>
    );
  }

  /**
   * Render Main Section
   */
  render() {
    const { isLoading, isLoaded } = this.props;
    const showLoading = isLoading ? 'show' : '';

    return (
      <div className={`content-wrapper form-wrapper ${showLoading}`}>
        <div className="form-wrapper__inner">
          <div className="entry-header">
            <h2 className="block-title">Profile</h2>
          </div>

          { isLoaded && this.renderLogo() }
          { isLoaded && this.renderProfileData() }
        </div>

        <LoadingOverlay />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    isLoading,
    error,
    errors,
    user,
    isLoaded
  } = state.user;

  return {
    isLoading,
    error,
    errors,
    user,
    isLoaded
  };
};

export default withRouter(connect(mapStateToProps)(ProfilePage));



// WEBPACK FOOTER //
// ./src/pages/Profile/index.js